import { render, staticRenderFns } from "./healthRecords.vue?vue&type=template&id=376f029c&scoped=true&"
import script from "./healthRecords.vue?vue&type=script&lang=js&"
export * from "./healthRecords.vue?vue&type=script&lang=js&"
import style0 from "./healthRecords.vue?vue&type=style&index=0&id=376f029c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376f029c",
  null
  
)

export default component.exports